// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const closedDrawerWidth = 80;
export const appDrawerWidth = 320;
